<template>
    <div ref="businesscontry" class="pbr-index-chart">
<Empty></Empty>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import {chartColors} from '../../../analysis/constant'
import Mixin from '../mixin'
import ResizeObserver from 'resize-observer-polyfill'
export default {
  name: 'pbrChartBusinessCountry',
  mixins: [Mixin],
  inject: ['chartDatas'],
  props: {
    data: {
      type: Array,
      require: true,
      default: () => []
    },
    height: { type: Number }
  },
  data () {
    return {
      businesscontryDom: null,
      businesscontryChart: null,
      optionBusinesscontry: null,
      isResize: false,
    }
  },
  computed: {
    chartData () {
      const businessChartData = this.chartDatas.businessChartData()
      // return projectChartData.businessCountryChart || [{}]
      if (businessChartData.hasOwnProperty('businessCountryChart') && businessChartData.businessCountryChart.length > 0) {
        return businessChartData.businessCountryChart
      }
      return [{name: '', num: 0, percent: 0}]
    }
  },
  methods: {
    drawChart (theme = 'light') {
      let self = this
      if(!this.$refs.businesscontry){
        return
      }
      if (this.businesscontryChart) {
        this.businesscontryChart.dispose()
      }
      let countContrastDom = this.$refs.businesscontry
      this.businesscontryChart = echarts.init(countContrastDom, theme)
      this.businesscontryChart.setOption(this.optionBusinesscontry)
      this.businesscontryChart.on('click', function (param) {
        self.dispatch('pbrIndex', 'filterData', {module: 'sj', condition: {type: 'country', title: param.data.name, id: param.data.id}})
        // self.dispatch('pbrIndex', 'filterData', {module: 'sj', countryName: param.name})
        // // self.$emit('business-country-chart-click', param.name)
        // let businessParams = self.$store.getters.pbrIndexModule.business
        // let isExist = businessParams.filter(d => d.id === param.id)
        // if (isExist.length === 0) {
        //   businessParams.push({id: 1, name: param.name})
        //   self.$store.commit('pbrIndexModule', {business: businessParams})
        // }
      })

      let that = this;
      let countContrastObserver = new ResizeObserver((entries) => {
        if (that.isResize) {
          that.businesscontryChart.resize()
          if (entries && entries.length > 0 && entries[0].borderBoxSize[0].blockSize > 0) {
            that.isResize = false;
          }
        }
      })
      countContrastObserver.observe(countContrastDom);
    },
    generateOptions () {
      this.optionBusinesscontry = {
        color: chartColors,
        title: {
          show: this.showTitle,
          text: this.$t('charts.home.opportunity.countriesDistribution'),
          left: 'center',
          top:0
        },
        tooltip: {
          trigger: 'item',
          confine:true,
          className: 'pbr-echarts-formatter-box',
          textStyle:{
            color:"inherit"
          },
          backgroundColor: "#fff",
          shadowBlur: 10,
          shadowColor: "rgba(0, 0, 0, .2)",
          shadowOffsetX: 1,
          shadowOffsetY: 2,
          borderRadius: 4,
          borderWidth: 1
        },
        dataset: {
          dimensions: ['name', 'num', 'percent'],
          source: this.chartData
        },
        yAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          inverse: true,
        },
        xAxis: {
        },

        series: {
          name:this.$t('charts.home.opportunity.countriesDistribution'),
          type: 'bar',
          barGap: '30%',
          colorBy:'data',
          label: {
            show: true
          },
          emphasis: {
            itemStyle: {
              fontSize: 18,
              opacity: 1
            }
          }
        },
        grid: {
          bottom:0,
          top: this.showTitle ? 30 : 0,
          left: 10,
          right: 10,
          containLabel: true
        }
      }
    },
    resize () {
      this.isResize = true
      this.businesscontryChart.resize()
    }
  },
  mounted () {
    this.generateOptions()
    this.drawChart(this.theme)
  },
  watch: {
    '$store.state.brpaModule.theme': {
      handler: function (val) {
        this.generateOptions()
        this.drawChart(val || 'white')
      },
      immediate:true
    },
    chartData: {
      handler (newValue, oldValue) {
        if (newValue.length === 0) {
          if (this.businesscontryChart) {
            this.businesscontryChart.dispose()
          }
        } else {
          this.generateOptions()
          this.drawChart(this.theme)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
